import { Cell, Gutter, IconDelete, IconEdit } from '@adserve/adserve-react-components';
import React, { useContext, useState, useEffect } from 'react';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';
import moment from 'moment';
import { BusinessTypes } from '../../../constants/Enums';
import { GetPlanSummary } from '../../../services/CampaignsDataService';

const AirtimeBurstsRow = ({ index, burst, scrollPx, onScroll, scrollableLength, rowHeight, visibleRows, campaign, deleteBurst, readOnly = false }) => {
    const { formatCurrency, dateFormat, formatNumber } = useContext(SystemSettingsContext);
    const [planSummary, setPlanSummary] = useState([]);
    const [errorState, setErrorState] = useState('');

    const maxVisibleLength = rowHeight * visibleRows;
    let stationList = {};
    const stations = [];
    const tomorrow = new Date(new Date().setHours(24, 0, 0, 0));

    if (burst?.burstStations) {
        stationList = JSON.parse(burst?.burstStations);

        for (const station in stationList) {
            stations.push(stationList[station].name);
        }
    }

    const getPlanSummary = (planId, stationId = 0) => {
        var pid = planId;

        if (pid) {
            GetPlanSummary(pid, stationId, window.emptyGuid)
                .then((result) => {
                    setPlanSummary(result);
                })
                .catch((error) => {
                    setErrorState(error.response.title);
                    setPlanSummary([]);
                });
        }
    };

    useEffect(() => {
        getPlanSummary(burst?.planId);
    }, []);

    const handleOpenBurstClick = () => {
        window.open(
            `${window.origin}/campaign-manager/campaigns/details?campaignId=${campaign.id}&burstId=${burst.id
            }&businessType=${encodeURIComponent(BusinessTypes.AIRTIMEBURST.name)}&readOnly=true&isBurst=true`,
            burst.name
        );
    };

    const handleEditBurst = () => {
        window.open(
            `${window.origin}/campaign-manager/campaigns/details?campaignId=${campaign.id}&burstId=${burst.id
            }&businessType=${encodeURIComponent(BusinessTypes.AIRTIMEBURST.name)}&readOnly=false&isBurst=true`,
            burst.name
        );
    };

    const handleDeleteBurst = () => {
        typeof deleteBurst === 'function' && deleteBurst(burst);
    };

    return (
        <>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                index={index}
                style={{ borderLeftWidth: 1 }}
            >
                {burst && (<>
                    <IconEdit
                        style={{
                            width: 18,
                            height: 21
                        }}
                        viewBox='0 0 50 50'
                        cursor='pointer'
                        onClick={handleEditBurst}
                        disabled={
                            //burst.campaignStatusName === 'Booked' ||
                            //burst.campaignStatusName === 'Running' ||
                            burst.campaignStatusName === 'Completed' ||
                            burst.campaignStatusName === 'Expired' ||
                            burst.campaignStatusName === 'Qualified Out'}
                    />
                    <IconDelete
                        style={{
                            width: 18,
                            height: 21
                        }}
                        viewBox='0 0 50 50'
                        cursor='pointer'
                        onClick={handleDeleteBurst}
                        disabled={!(
                            burst.campaignStatusName === 'Draft' ||
                            // burst.campaignStatusName === 'Reserved' ||
                            // burst.campaignStatusName === 'Expired'
                            burst.campaignStatusName === 'Qualified Out'
                        ) || burst.versionNumber > 1}
                    />
                </>
                )}
            </Cell>
            <Cell
                align='center'
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                index={index}
                style={{ cursor: burst ? 'pointer' : 'default', color: '#1101BE', justifyContent: 'flex-start' }}
                onClick={handleOpenBurstClick}
            >
                {burst?.name ? burst?.name : ''}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                index={index}
                style={{ fontWeight: 'normal', justifyContent: 'flex-start' }}
            >
                {burst ? burst.versionNumber ? `Version ${burst.versionNumber}` : 'Version 1' : ''}
            </Cell>
            <Cell
                align='center'
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                index={index}
                style={{ fontWeight: '400', whiteSpace: 'nowrap', justifyContent: 'flex-start' }}
            >
                {!stations?.length ? '' : stations.length === 1 ? stations : `Multiple (${stations.length} stations)`}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                index={index}
                style={{ fontWeight: 'normal', justifyContent: 'flex-start' }}
            >
                {burst?.startDate ? moment(burst?.startDate).format(`${dateFormat}`) : ''}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                index={index}
                style={{ fontWeight: 'normal', justifyContent: 'flex-start' }}
            >
                {burst?.endDate ? moment(burst?.endDate).format(`${dateFormat}`) : ''}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                index={index}
                style={{ fontWeight: 'normal', justifyContent: 'flex-end' }}
            >
                {burst?.spots && burst?.spots}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                index={index}
                style={{ fontWeight: 'normal', justifyContent: 'flex-end' }}
            >
                {burst?.impacts && formatNumber(burst?.impacts)}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                index={index}
                style={{ fontWeight: 'normal', justifyContent: 'flex-end' }}
            >
                {planSummary?.basePopulation &&
                    formatNumber((planSummary?.baseReach / planSummary?.basePopulation) * 100)}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                index={index}
                style={{ fontWeight: 'normal', justifyContent: 'flex-end' }}
            >
                {planSummary?.baseOTH && formatNumber(planSummary?.baseOTH)}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                index={index}
                style={{ fontWeight: 'normal', justifyContent: 'flex-end' }}
            >
                {planSummary?.baseWeeklyOTH && formatNumber(planSummary?.baseWeeklyOTH)}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                index={index}
                style={{ fontWeight: 'normal', justifyContent: 'flex-end' }}
            >
                {burst?.targetImpacts && formatNumber(burst?.targetImpacts)}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                index={index}
                style={{ fontWeight: 'normal', justifyContent: 'flex-end' }}
            >
                {planSummary?.targetPopulation &&
                    formatNumber((planSummary?.targetReach / planSummary?.targetPopulation) * 100)}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                index={index}
                style={{ fontWeight: 'normal', justifyContent: 'flex-end' }}
            >
                {planSummary?.targetOTH && formatNumber(planSummary?.targetOTH)}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                index={index}
                style={{ fontWeight: 'normal', justifyContent: 'flex-end' }}
            >
                {planSummary?.targetWeeklyOTH && formatNumber(planSummary?.targetWeeklyOTH)}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                index={index}
                style={{ fontWeight: 'normal', justifyContent: 'flex-end' }}
            >
                {burst?.spendDiscounted && formatCurrency(burst?.spendDiscounted)}
            </Cell>
            <Cell
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                index={index}
                style={{ fontWeight: 'normal', justifyContent: 'flex-start' }}
            >
                {burst?.campaignStatusName && burst?.campaignStatusName}
            </Cell>
            {index === 0 && (
                <Gutter
                    rowHeight={rowHeight}
                    visibleRows={visibleRows}
                    scrollPx={scrollPx}
                    index={index}
                    maxVisibleLength={maxVisibleLength}
                    scrollableLength={scrollableLength}
                    onScroll={onScroll}
                ></Gutter>
            )}

            {index >= visibleRows && <div></div>}
        </>
    );
};

export default AirtimeBurstsRow;
